/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_RadiusInputs */

const cs_requirements_radius = /** @type {(inputs: Requirements_RadiusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okruh (km)`)
};

const en_requirements_radius = /** @type {(inputs: Requirements_RadiusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radius (km)`)
};

/**
* | output |
* | --- |
* | "Radius (km)" |
*
* @param {Requirements_RadiusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_radius = /** @type {((inputs?: Requirements_RadiusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_RadiusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_radius(inputs)
	return cs_requirements_radius(inputs)
});